export default "__VITE_ASSET__CWp1hDfI__"